
import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown, Globe } from "lucide-react";

interface CountryDropdownProps {
  countries: string[];
  selectedCountry: string | null;
  onCountrySelect: (country: string) => void;
}

export const CountryDropdown: React.FC<CountryDropdownProps> = ({
  countries,
  selectedCountry,
  onCountrySelect,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="w-full sm:w-[200px] flex items-center justify-between gap-2">
          <Globe className="h-4 w-4" />
          <span className="flex-1 text-left truncate">{selectedCountry || 'Select Country'}</span>
          <ChevronDown className="h-4 w-4 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-[200px] max-h-[250px] overflow-y-auto">
        {countries.map((country) => (
          <DropdownMenuItem
            key={country}
            className="cursor-pointer"
            onClick={() => onCountrySelect(country)}
          >
            {country}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
